<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Órdenes de trabajo</h3>
      </div>
      <div class="layout__controls">
        <button class="btn-info" type="button" @click="consultar">
          <i class="fa fa-search"></i>
          <span>Consultar</span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              id="persona"
              v-model="selectedPersona"
              :options="personas"
              label="nombre"
            ></v-select>
            <label for="persona">Persona</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              id="vendedor"
              v-model="selectedVendedor"
              :options="vendedores"
              label="nombre"
            ></v-select>
            <label for="vendedor">Vendedor</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-inline">
          <label>
            <strong>Filtros por estado</strong>
          </label>
          <label for="abiertas">
            <input
              @change="consultar"
              type="radio"
              v-model="form.estado"
              name="estado"
              id="abiertas"
              value="A"
            />
            <span>Abiertas</span>
          </label>
          <label for="asignadas">
            <input
              @change="consultar"
              type="radio"
              v-model="form.estado"
              name="estado"
              id="asignadas"
              value="V"
            />
            <span>Asignadas</span>
          </label>
          <label for="facturables">
            <input
              @change="consultar"
              type="radio"
              v-model="form.estado"
              name="estado"
              id="facturables"
              value="B"
            />
            <span>Facturables</span>
          </label>
          <label for="facturadas">
            <input
              @change="consultar"
              type="radio"
              v-model="form.estado"
              name="estado"
              id="facturadas"
              value="F"
            />
            <span>Facturadas</span>
          </label>
          <label for="cerradas">
            <input
              @change="consultar"
              type="radio"
              v-model="form.estado"
              name="estado"
              id="cerradas"
              value="C"
            />
            <span>Cerradas</span>
          </label>
          <label for="anuladas">
            <input
              @change="consultar"
              type="radio"
              v-model="form.estado"
              name="estado"
              id="anuladas"
              value="E"
            />
            <span>Anuladas</span>
          </label>
          <label for="todas">
            <input
              @change="consultar"
              type="radio"
              v-model="form.estado"
              name="estado"
              id="todas"
              value="T"
            />
            <span>Todas</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-inline">
          <label>
            <strong>Filtros por fecha</strong>
          </label>
          <label for="hoy">
            <input
              @change="consultar"
              v-model="form.tipo_fecha"
              type="radio"
              name="tipo_fecha"
              id="hoy"
              value="H"
            />
            <span>Hoy</span>
          </label>
          <label for="ayer">
            <input
              @change="consultar"
              v-model="form.tipo_fecha"
              type="radio"
              name="tipo_fecha"
              id="ayer"
              value="A"
            />
            <span>Ayer</span>
          </label>
          <label for="rango">
            <input
              @change="changePersonalizado"
              v-model="form.tipo_fecha"
              type="radio"
              name="tipo_fecha"
              id="rango"
              value="P"
            />
            <span>Personalizado</span>
          </label>
          <div class="form-field" v-show="form.tipo_fecha === 'P'">
            <div class="datepicker-field datepicker-field--stretch">
              <VueCtkDateTimePicker
                id="desde"
                v-model="form.desde"
                locale="es"
                no-label
                only-date
                auto-close
                button-now-translation="Ahora"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                label="Seleccione una fecha..."
              />
              <label>Desde</label>
            </div>
          </div>
          <div class="form-field" v-show="form.tipo_fecha === 'P'">
            <div
              class="datepicker-field datepicker-field--stretch"
              v-show="form.tipo_fecha === 'P'"
            >
              <VueCtkDateTimePicker
                id="hasta"
                v-model="form.hasta"
                locale="es"
                no-label
                only-date
                auto-close
                button-now-translation="Ahora"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                label="Seleccione una fecha..."
              />
              <label>Hasta</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-inline">
          <label>
            <strong>Filtros de comprobante</strong>
          </label>
          <label for="conProforma">
            <input
              @change="consultar"
              type="radio"
              name="conProforma"
              id="conProforma"
              v-model="form.con_proforma"
              value="C"
            />
            <span>Con proforma</span>
          </label>
          <label for="sinProforma">
            <input
              @change="consultar"
              type="radio"
              name="conProforma"
              id="sinProforma"
              v-model="form.con_proforma"
              value="S"
            />
            <span>Sin proforma</span>
          </label>
          <label for="ambos">
            <input
              @change="consultar"
              type="radio"
              name="conProforma"
              id="ambos"
              v-model="form.con_proforma"
              value="A"
            />
            <span>Ambos</span>
          </label>
          <div class="form-field">
            <input-field
              id="numeroProforma"
              v-model="form.numero_proforma"
              placeholder="Digite un número..."
            >
              <span>Número de proforma</span>
            </input-field>
          </div>
          <div class="form-field">
            <input-field
              id="numero_orden_trabajo"
              v-model="form.numero_orden_trabajo"
              placeholder="Digite un número..."
            >
              <span>Número de orden de trabajo</span>
            </input-field>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <k-table
          tipoDocumento="OT"
          :filterStatus="false"
          :searchEnabled="false"
          :editButton="false"
          ref="tablaOrdenesTrabajo"
          :createButton="false"
          @ver="ver"
          :buttons="[
                {
                    text : '',
                    class : 'btn-info',
                    icon : 'fa-eye',
                    event : 'ver'
                }
            ]"
          :deleteButton="false"
          @seleccionar="seleccionar"
          :path="path"
          :params="form"
          :columns="[
                    {
                        display : 'Fecha de emisión',
                        value : 'fecha_emision'
                    },
                    {
                        display : 'Número de documento',
                        value : 'numero_documento'
                    },
                    {
                        display : 'Nombre de persona',
                        value : 'nombre_persona'
                    },
                    {
                        display : 'Vendedor asignado',
                        value : 'nombre_vendedor'
                    },
                    {
                        display : 'N° Proforma',
                        value : 'numero_proforma',
                    },
                    {
                        display : 'Comentario',
                        value : 'comentario',
                    },
                    {
                        display : 'Costo total',
                        value : 'costo_total',
                        numeric : true
                    },
                    {
                        display : 'Fecha de creación',
                        value : 'created_at'
                    },
                    {
                        display : 'Estado',
                        value : 'descripcion_estado'
                    }
                ]"
        ></k-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        desde: "",
        hasta: "",
        tipo_fecha: "H",
        con_proforma: "A",
        numero_proforma: "",
        estado: "T",
        numero_orden_trabajo: ""
      },
      personas: [],
      vendedores: [],
      selectedPersona: null,
      selectedVendedor: null,
      path: url + "/orden-trabajo"
    };
  },
  methods: {
    ver : function (comprobante) {
      window.open(url + '/orden-trabajo/' + comprobante.id + '/edit', '_blank');
    },  
    changePersonalizado: function() {
      let hasta = new Date();
      let desde = new Date();
      desde.setDate(desde.getDate() - 30);
      this.form.desde = moment(desde).format("YYYY-MM-DD");
      this.form.hasta = moment(hasta).format("YYYY-MM-DD");
      this.consultar();
    },
    cargarDatos: function() {
      let that = this;
      axios.get(url + "/datos-orden-trabajo").then(function(response) {
        that.personas = response.data.personas;
        that.vendedores = response.data.vendedores;
      });
    },
    consultar: function() {
      this.$refs.tablaOrdenesTrabajo.loadRows();
    },
    seleccionar: function(ordenTrabajo) {
      this.$emit("selected", ordenTrabajo);
    }
  },
  mounted: function() {
    this.cargarDatos();
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ordenes-trabajo/ListaOrdenesTrabajo.vue